export default __webpack_public_path__ + "static/hackathon-grid-1-3cdc3b9d80dc9c3856f49dc2682ff13c.png";